"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpecificColor = exports.getVersion = exports.getProperties = exports.getTypography = exports.getDefaultProps = exports.getColor = void 0;

var _get2 = _interopRequireDefault(require("lodash-es/get"));

var _camelCase2 = _interopRequireDefault(require("lodash-es/camelCase"));

var _isEmpty2 = _interopRequireDefault(require("lodash-es/isEmpty"));

var _isObject2 = _interopRequireDefault(require("lodash-es/isObject"));

var _tokens = require("../../tokens");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getVersion = function getVersion(propsOrVersion) {
  return (0, _isObject2["default"])(propsOrVersion) ? propsOrVersion.version : propsOrVersion;
};

exports.getVersion = getVersion;

var getColor = function getColor(propsOrVersion, component) {
  var version = getVersion(propsOrVersion);
  return (0, _get2["default"])((0, _get2["default"])(_tokens.colors, version, _tokens.colors["default"]), component, {});
};

exports.getColor = getColor;

var getDefaultProps = function getDefaultProps(propsOrVersion, Component) {
  var name = Component.displayName,
      props = Component.defaultProps;
  var versionedProps = (0, _get2["default"])(_tokens.defaultProps, "".concat(getVersion(propsOrVersion), ".").concat((0, _camelCase2["default"])(name)), {});

  if (!(0, _isEmpty2["default"])(versionedProps)) {
    props = _objectSpread({}, props, versionedProps);
  }

  return props;
};

exports.getDefaultProps = getDefaultProps;

var getTypography = function getTypography(propsOrVersion, component) {
  var version = getVersion(propsOrVersion);
  return (0, _get2["default"])((0, _get2["default"])(_tokens.typography, version, _tokens.typography["default"]), component, {});
};

exports.getTypography = getTypography;

var getProperties = function getProperties(propsOrVersion, component) {
  var version = getVersion(propsOrVersion);
  return (0, _get2["default"])((0, _get2["default"])(_tokens.properties, version, _tokens.properties["default"]), component, {});
};

exports.getProperties = getProperties;

var getSpecificColor = function getSpecificColor(propsOrVersion, color) {
  if (_tokens.colorPattern.test(color)) {
    return color;
  }

  var version = getVersion(propsOrVersion);

  if (_tokens.pureColors[version][color]) {
    return _tokens.pureColors[version][color];
  }

  if (_tokens.baseColors[color]) {
    return _tokens.baseColors[color];
  }

  return null;
};

exports.getSpecificColor = getSpecificColor;